import { register, CloudObject, defineProperty, defineRelation, Direction } from 'olympe';
import TranslatedString from "./TranslatedString";

/**
 * @extends {CloudObject}
 */
export default class InspectionEntity extends CloudObject {
    
    /**
     * @return {string}
     */
    getName() {
        return this.get(InspectionEntity.nameProp);
    }

    /**
     * @return {string}
     */
    getDescription() {
        return this.get(InspectionEntity.descriptionProp);
    }

    /**
     * @return {number}
     */
    getRank() {
        return this.get(InspectionEntity.rankProp);
    }
}

// Hardcoded tags
register('01880b4621fd73c394b0', InspectionEntity);
InspectionEntity.nameProp = defineProperty('0189923420819344836e');
InspectionEntity.descriptionProp = defineProperty('018992345e173628bcd1');
InspectionEntity.rankProp = defineProperty('0189b5652d76cba4e067');
InspectionEntity.documentsRel = defineRelation('01880b4668741525e657');
InspectionEntity.picturesRel = defineRelation('01880b4800deb92600d6');
InspectionEntity.presumedStatesRel = defineRelation('01880b497227ef6db299');
InspectionEntity.translatedNameRel = defineRelation('018992356388c601d2f4', InspectionEntity, TranslatedString);
InspectionEntity.translatedDescriptionRel = defineRelation('01899235976073b73281', InspectionEntity, TranslatedString);
InspectionEntity.inverse_feedbacktargetRel = defineRelation('01880fbba294002b16c5', Direction.ORIGIN);
InspectionEntity.inverse_observationtargetRel = defineRelation('01880fc0f576af2ee0ed', Direction.ORIGIN);
InspectionEntity.inverse_weightingFactoritemRel = defineRelation('01894f168fb8484869a9', Direction.ORIGIN);
InspectionEntity.inverse_aHPValueitemRel = defineRelation('01894f173ae27a21840d', Direction.ORIGIN);
